import React from 'react'
import { X } from 'react-feather'
import { isNotAllowed, notAllowedText } from '../../utils'

const RenderedHTML = ({data}) => {
  console.log({data})
  const html = data.substring(1, data.length-1).split(/\r?\n/).join('')

  return (
    <>
      <p className="mb-4">Something wrong with the API endpoint. Details:</p>
      <iframe srcDoc={html} title="RenderedHTMLIframe" className="w-full h-64"></iframe>
    </>
    // <div className="prose" dangerouslySetInnerHTML={{__html: html}} />
  )
}

const AlertError = ({message, onClose}) => {
  const messageRenderer = (message) => {
    let result = ''

    if(isNotAllowed(message)){
      result = notAllowedText
    } else if(typeof message === 'string') {
      if(message.includes('DOCTYPE') || message.includes('doctype')){
        result = <RenderedHTML data={message}/>
      } else {
        result = message
      }
    } else {
      result = JSON.stringify(message)
    }

    if(typeof result.replace === 'function'){
      const replaced = result.replace("typeAudience", '"Suitable For"');
      const replaced1 = replaced.replace("typeApproach", '"Approaches"');
      const replaced2 = replaced1.replace("typeIssues", '"Issues"');
      const replaced3 = replaced2.replace("kategoriArtikel", '"Categories"');

      result = replaced3
    }

    return result
  }

  const messageRendered = messageRenderer(message)

  return (
    <div className="w-full p-4 shadow rounded mt-4 bg-red-300 overflow-x-auto">
      <div className="flex justify-between items-center mb-2">
        <p className="font-bold">Error.</p>
        {
          onClose &&
          <p className="cursor-pointer" onClick={onClose}>
            <X />
          </p>
        }
      </div>
      <div>{messageRendered}</div>
    </div>
  )
}

export { AlertError }
